<template>
  <div class="approveCooperation"> approveCooperation </div>
</template>

<script>
  export default {
    name: 'approveCooperation',
  };
</script>

<style></style>
